import { Component, OnInit } from '@angular/core';

import { getObjectiveOthersSelectors } from 'src/app/modules/objective/store/objective.selectors';
import { IObjectivesFormState } from 'src/app/modules/objective/store/objective.state';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { formatDate } from 'src/app/utils/format-date';
import { formatCurrency } from 'src/app/utils/format-currency';

@Component({
  selector: 'app-pdf-others',
  templateUrl: './pdf-others.component.html',
  styleUrls: ['./pdf-others.component.scss'],
})
export class PdfOthersComponent implements OnInit {
  dataStoreOthers$: Observable<any>;
  dataStoreOthers: IObjectivesFormState;
  intendDate: any;
  minInvestimentFormated: string;
  maxInvestimentFormated: string;

  constructor(private store: Store) {}

  getState() {
    this.dataStoreOthers$ = this.store.select(getObjectiveOthersSelectors);
    this.dataStoreOthers$.subscribe((value) => {
      this.dataStoreOthers = {
        ...(this.dataStoreOthers = value),
      };
    });

    this.intendDate = this.dataStoreOthers.date;
    if (this.intendDate) {
      this.intendDate = formatDate(this.intendDate);
    } else {
      this.intendDate = 'data não especificada!';
    }

    this.minInvestimentFormated = formatCurrency(
      this.dataStoreOthers.minimumInvestment
    );
    this.maxInvestimentFormated = formatCurrency(
      this.dataStoreOthers.maximumInvestment
    );
  }

  ngOnInit(): void {
    this.getState();
  }
}
